/** Primera letra en mayuscula; el resto se deja igual. */
export function capitalizeFirstLetter(value?: string | null): string {
  const text = (value ?? '').trim();
  if (!text) {
    return '';
  }
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/** Primera letra de cada palabra en mayuscula. */
export function capitalizeWords(value?: string | null): string {
  const text = (value ?? '').trim();
  if (!text) {
    return '';
  }
  return text.split(/\s+/).map((word) => capitalizeFirstLetter(word)).join(' ');
}

/** Nombre completo para tabla Congregacion (1ra letra de cada parte). */
export function formatNombreCompletoDisplay(
  nombre?: string | null,
  nombre2?: string | null,
  apellido?: string | null,
): string {
  return [nombre, nombre2, apellido]
    .map((part) => capitalizeFirstLetter(part))
    .filter(Boolean)
    .join(' ');
}

/**
 * Minusculas sin tildes/diacriticos (para alta de persona / busqueda).
 * Conserva espacios y demas caracteres.
 */
export function toPlainLowercase(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

/** Nombre y segundo nombre: minusculas, sin espacios. */
export function sanitizeNombrePersona(value: string): string {
  return toPlainLowercase(value).replace(/\s+/g, '');
}

/**
 * Apellido: minusculas y un solo espacio.
 * Conserva el espacio final mientras se escribe la segunda palabra.
 */
export function sanitizeApellidoPersona(value: string): string {
  const plain = toPlainLowercase(value).replace(/^\s+/, '');
  const dejaEspacioFinal = /\s$/.test(plain) && !plain.slice(0, -1).includes(' ');
  const partes = plain.trim().split(/\s+/).filter(Boolean);

  if (partes.length === 0) {
    return '';
  }
  if (partes.length === 1) {
    return dejaEspacioFinal ? `${partes[0]} ` : partes[0];
  }
  return `${partes[0]} ${partes[1]}`;
}